import React from "react";
import {PaymentResultContainer} from "./styled";

export const PaymentResult = () => {
    return <PaymentResultContainer>
        asdfasdf;jafe;jndjdfdgnjks
    </PaymentResultContainer>
}
